import { memo } from "react";
import { Icon } from "../Common.jsx";
import ProgressBar from "./ProgressBar.jsx";

const fmtD = (d) =>
  d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : null;

const progressColor = (pct) =>
  pct >= 80 ? "var(--success)" : pct >= 40 ? "var(--warning)" : "var(--error)";

function ProjectCard({ project, meta, onOpen }) {
  const st =
    (meta?.statuses || []).find((s) => s.value === project.status) || {
      label: project.status,
      badge: "badge-muted",
    };
  const pct = Math.min(100, Math.max(0, project.progressPct || 0));
  const total = project.taskTotal || 0;
  const done = project.taskCompleted || 0;
  const barColor = progressColor(pct);

  return (
    <div
      className="card project-card"
      role="button"
      tabIndex={0}
      onClick={onOpen}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onOpen();
        }
      }}
    >
      <div className="pc-head">
        <span className="pc-icon">
          <Icon name="folder" size={18} />
        </span>
        <div className="pc-head-text">
          <div className="pc-name" title={project.name}>
            {project.name}
          </div>
          <span className={`badge ${st.badge} pc-status`}>{st.label}</span>
        </div>
      </div>

      <div className="pc-desc">
        {project.description || "No description provided."}
      </div>

      <div className="pc-progress">
        <div className="pc-progress-top">
          <span className="pc-tasks">
            <Icon name="check-square" size={13} /> {done}/{total} task{total === 1 ? "" : "s"}
          </span>
          <span className="pc-pct" style={{ color: barColor }}>
            {pct}%
          </span>
        </div>
        <div role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
          <ProgressBar pct={pct} height={7} />
        </div>
      </div>

      <div className="pc-foot">
        <span className={`pc-due ${project.overdue ? "overdue" : ""}`}>
          <Icon name="calendar" size={13} />
          {project.deadline ? fmtD(project.deadline) : "No deadline"}
        </span>
        {project.overdue ? (
          <span className="badge badge-error pc-overdue">
            <Icon name="alert-triangle" size={12} /> Overdue
          </span>
        ) : (
          <span className="pc-open">
            Open <Icon name="arrow-right" size={13} />
          </span>
        )}
      </div>
    </div>
  );
}

export default memo(ProjectCard);
